import React from 'react';
import { AppButton, Box, DownloadIcon, Preloader, Text } from '@common-fe/common-fe';

export interface ItemProps {
  onClick: () => void;
  isLoading?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  testId?: string;
}
const Item: React.FC<ItemProps> = ({
  testId = 'export-report-item',
  children,
  onClick,
  disabled,
  isLoading,
}) => {
  return (
    <Box
      data-testid={testId}
      justify="between"
      align="center"
      round="snackbarRound"
      border={{ size: 'large', color: 'border2' }}
      direction="row"
      pad={{ vertical: 'spacing8', horizontal: 'spacing12' }}
    >
      <Text weight={700}>{children}</Text>
      <AppButton
        testId={`${testId}`}
        disabled={disabled}
        style={{ padding: 0 }}
        width="40px"
        onClick={onClick}
      >
        {isLoading ? <Preloader testId={`${testId}_loading`} /> : <DownloadIcon></DownloadIcon>}
      </AppButton>
    </Box>
  );
};

export default Item;
